<nav class="navbar navbar-light bg-light navbar-expand-lg mb-3" style="margin-bottom: 0 !important;">
  <form class="form-inline flex-fill" id="formularioFiltros">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul class="navbar-nav me-auto">
      <div style="width:auto" class="input-group ms-2 me-2">
        <li class="nav-item">
          <input type="date" [ngModel]="modelDesde" class="fechaFormControlDesdeHasta" placeholder="aaaa-mm-dd"
            (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker #d="ngbDatepicker" value="modelDesde"
            ngbTooltip="Seleccione una fecha de inicio" class="form-control form-control-rounded"
            #searchDate readonly>
        </li>
        <li class="nav-item me-2">
          <div style="width:auto" class="input-group-append">
            <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary" (click)="d.toggle()">
              <i class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </li>
        <li class="nav-item">
          <input type="date" [ngModel]="modelHasta" class="fechaFormControlDesdeHasta" placeholder="aaaa-mm-dd"
                 (ngModelChange)="modelHasta = $event" name="dt" ngbDatepicker #h="ngbDatepicker" value="modelHasta"
                 ngbTooltip="Seleccione una fecha de fin" class="form-control form-control-rounded"
                 #searchDate readonly>
        </li>
        <li class="nav-item me-2">
          <div class="input-group-append">
            <button id="botonHasta" type="button" class="input-group-btn btn btn-secondary" (click)="h.toggle()">
              <i class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </li>
        <li class="nav-item">
          <button (click)="buscardatos()" [disabled]="fechaDesdeMayorQueHasta()==true || loading"
            class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i class="fa fa-search" aria-hidden="true"></i></button>
        </li>
      </div>
      <div style="width:auto" class="input-group me-2">
        <li class="nav-item">
          <button (click)="cambiarTabla(TipoPrecioReporte.PreciosSubidos)" [disabled]="fechaDesdeMayorQueHasta()==true || loading"
            class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i
              aria-hidden="true"></i>Precios subidos</button>
        </li>

        <li class="nav-item">
          <button (click)="cambiarTabla(TipoPrecioReporte.PreciosAprobados)" [disabled]="fechaDesdeMayorQueHasta()==true || loading"
            class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i
              aria-hidden="true"></i>Gestión de lotes</button>
        </li>

        <li class="nav-item">
          <button (click)="cambiarTabla(TipoPrecioReporte.PreciosFacturados)" [disabled]="loading"
                  class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit"><i aria-hidden="true"></i>Precios utilizados</button>
        </li>
        @if (tipoPrecioReporte === TipoPrecioReporte.PreciosFacturados){
          <li class="nav-item">
            <button (click)="exportar()" [disabled]="loading || exportando" class="btn btn-outline-success my-2 my-lg-0 mx-lg-2">
              <span *ngIf="!exportando">Descargar</span>
              <div *ngIf="exportando" class="d-flex align-items-center">
                <div class="spinner-border text-success spinner-border-sm" role="status"></div>
                <span>Descargando...</span>
              </div>
            </button>
          </li>
        }
      </div>
    </ul>
  </form>
</nav>

<div class="card-body">
  <form class="mb-3">
    <div class="col col-md-12">
      <div class="spinner-container" *ngIf="loading">
        <ngx-spinner name="spinnerLista" bdOpacity=0.3bd
          Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white">{{messageDescarga}}</p>
        </ngx-spinner>
      </div>

      <ng-container *ngIf="this.tipoPrecioReporte == TipoPrecioReporte.PreciosSubidos">
        <ngb-alert *ngIf="!loading && this.listadoPreciosSubidos.length == 0">No hay lotes para busqueda seleccionada.
        </ngb-alert>
        <table id="tabla" class="table table-sm table-hover text-center"
          *ngIf="!loading && this.listadoPreciosSubidos.length > 0 && this.listadoPreciosSubidos != null">
          <thead>
            <tr>
              <th>Lote</th>
              <th>Subido</th>
              <th>Fecha</th>
              <th>Descarga</th>
            </tr>
          </thead>
          <tbody [formGroup]="tablaPreciosSubidos">
            <tr *ngFor="let l of listadoPreciosSubidos; let i = index">
              <td>{{l.numeroLote}}</td>
              <td>{{l.responsable}}</td>
              <td>{{l.fechaPublicacion | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td *ngIf="!this.descargando" (click)="descargarPreciosSubidos(i)"><i class="fa fa-download"></i></td>
              <td *ngIf="this.descargando" [ngClass]="[l.loadIcon ? 'fa fa-spinner fa-spin' : 'fa fa-download']">
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="this.tipoPrecioReporte == TipoPrecioReporte.PreciosAprobados">
        <ngb-alert *ngIf="!loading && this.listadoPreciosAprobados.length == 0">No hay precios para busqueda seleccionada.
        </ngb-alert>
        <table id="tabla" class="table table-sm table-hover text-center"
          *ngIf="!loading && this.listadoPreciosAprobados.length > 0 && this.listadoPreciosAprobados != null">
          <thead>
            <tr>
              <th>Num. lote</th>
              <th>Cantidad</th>
              <th>Usuario</th>
              <th>Fecha</th>
              <th>Descarga</th>
            </tr>
          </thead>
          <tbody [formGroup]="tablaPreciosAprobados">
            <tr *ngFor="let l of listadoPreciosAprobados; let i = index">
              <td>{{l.numeroLote}}</td>
              <td>{{l.cantidadRegistros}}</td>
              <td>{{l.usuarioAprobador}}</td>
              <td>{{l.fechaAprobacion | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td *ngIf="!this.descargando" (click)="descargarPreciosAprobados(i)"><i class="fa fa-download"></i></td>
              <td *ngIf="this.descargando" [ngClass]="[l.loadIcon ? 'fa fa-spinner fa-spin' : 'fa fa-download']">
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>


      @if (tipoPrecioReporte == TipoPrecioReporte.PreciosFacturados) {
        <ngb-alert *ngIf="!loading && listadoPreciosFacturados.length == 0">No hay precios para busqueda seleccionada.
        </ngb-alert>
        <div class="tabla-precios"
            infinite-scroll
            [infiniteScrollDistance]="distance"
            [infiniteScrollThrottle]="throttle"
            [scrollWindow]="false"
            [infiniteScrollDisabled]="obteniendoPreciosScroll || stopScroll"
            (scrolled)="onScrollPrecios()">
          <table id="tabla" class="table table-sm table-hover text-center"
              *ngIf="!loading && listadoPreciosFacturados.length > 0">
            <thead class="text-center">
            <tr style="z-index: 50">
              <th>Aerovale</th>
              <th>Matr&iacute;cula</th>
              <th>ProductoC&oacute;digo</th>
              <th>ProductoNombre</th>
              <th>UnidadDeMedida</th>
              <th>Cantidad</th>
              <th>TipoOperaci&oacute;n</th>
              <th>Rancho</th>
              <th>FechaDespacho</th>
              <th>C&oacute;digoAeroplantaDespacho</th>
              <th>N&uacute;meroAeroplantaDespacho</th>
              <th>Descripci&oacute;nAeroplantaDespacho</th>
              <th>CiudadDeDespacho</th>
              <th>C&oacute;digoDirecci&oacute;nDeEntrega</th>
              <th>CiudadDirecci&oacute;nDeEntrega</th>
              <th>ProvinciaDirecci&oacute;nDeEntrega</th>
              <th>PrefijoRemito</th>
              <th>N&uacute;meroRemito</th>
              <th>CentroEmisorFactura</th>
              <th>N&uacute;meroFactura</th>
              <th>LetraFactura</th>
              <th>FechaFactura</th>
              <th>FechaVencimiento</th>
              <th>C&oacute;digoAeroplantaFactura</th>
              <th>N&uacute;meroAeroplantaFactura</th>
              <th>NombreAeroplantaFactura</th>
              <th>C&oacute;digoMonedaFactura</th>
              <th>Descripci&oacute;nMonedaFactura</th>
              <th>ClienteCuenta</th>
              <th>ClienteDocumento</th>
              <th>ClienteRaz&oacute;nSocial</th>
              <th>LotePrecio</th>
              <th>NivelPrecio</th>
              <th>AreaPrecio</th>
              <th>SegmentoPrecio</th>
              <th>MonedaPrecio</th>
              <th>C&oacute;digoDirecci&oacute;nDeEntregaPrecio</th>
              <th>FechaDesde</th>
              <th>FechaHasta</th>
              <th>PrecioFacturado</th>
              <th>PrecioLista</th>
              <th>TipoBonificaci&oacute;nRecargo</th>
              <th>ValorBonificaci&oacute;nRecargo</th>
              <th>ValorIva</th>
              <th>ValorIIBB</th>
              <th>Percepci&oacute;nIVA</th>
              <th>ValorIDC</th>
              <th>ValorICL</th>
              <th>%BIO</th>
              <th>Comercial</th>
              <th>CuentaSap</th>
              <th>ComentarioAerovale</th>
              <th>Expendedora</th>
            </tr>
            </thead>
            <tbody [formGroup]="tablaPreciosFacturados">
              <tr *ngFor="let l of listadoPreciosFacturados; let i = index">
                <td>{{l.aerovale}}</td>
                <td>{{l.matricula}}</td>
                <td>{{l.productoCodigo}}</td>
                <td>{{l.productoNombre}}</td>
                <td>{{l.unidadDeMedida}}</td>
                <td>{{l.cantidad}}</td>
                <td>{{l.tipoOperacion}}</td>
                <td>{{l.rancho}}</td>
                <td>{{l.fechaDespacho | date: 'dd/MM/yyyy hh:mm a'}}</td>
                <td>{{l.codigoAeroplantaDespacho}}</td>
                <td>{{l.numeroAeroplantaDespacho}}</td>
                <td>{{l.descripcionAeroplantaDespacho}}</td>
                <td>{{l.ciudadDeDespacho}}</td>
                <td>{{l.codigoDireccionDeEntrega}}</td>
                <td>{{l.ciudadDireccionDeEntrega}}</td>
                <td>{{l.provinciaDireccionDeEntrega}}</td>
                <td>{{l.prefijoRemito}}</td>
                <td>{{l.numeroRemito}}</td>
                <td>{{l.centroEmisorFactura}}</td>
                <td>{{l.numeroFactura}}</td>
                <td>{{l.letraFactura}}</td>
                <td>{{l.fechaFactura | date: 'dd/MM/yyyy'}}</td>
                <td>{{l.fechaVencimiento | date: 'dd/MM/yyyy hh:mm a'}}</td>
                <td>{{l.codigoAeroplantaFactura}}</td>
                <td>{{l.numeroAeroplantaFactura}}</td>
                <td>{{l.nombreAeroplantaFactura}}</td>
                <td>{{l.codigoMonedaFactura}}</td>
                <td>{{l.descripcionMonedaFactura}}</td>
                <td>{{l.clienteCuenta}}</td>
                <td>{{l.clienteDocumento}}</td>
                <td>{{l.clienteRazonSocial}}</td>
                <td>{{l.lotePrecio}}</td>
                <td>{{l.nivelPrecio}}</td>
                <td>{{l.areaPrecio}}</td>
                <td>{{l.segmentoPrecio}}</td>
                <td>{{l.monedaPrecio}}</td>
                <td>{{l.codigoDireccionDeEntregaPrecio}}</td>
                <td>{{l.fechaDesde | date: 'dd/MM/yyyy hh:mm a'}}</td>
                <td>{{l.fechaHasta | date: 'dd/MM/yyyy hh:mm a'}}</td>
                <td>{{l.precioFacturado | number : '1.2-2'}}</td>
                <td>{{l.precioLista | number : '1.2-2'}}</td>
                <td>{{l.tipoBonificacionRecargo}}</td>
                <td>{{l.valorBonificacionRecargo}}</td>
                <td>{{l.valorIva | number : '1.2-2'}}</td>
                <td>{{l.valorIIBB | number : '1.2-2'}}</td>
                <td>{{l.percepcionIva}}</td>
                <td>{{l.valorIDC | number : '1.2-2'}}</td>
                <td>{{l.valorICL | number : '1.2-2'}}</td>
                <td>{{l.porcentajeBIO}}</td>
                <td>{{l.comercial}}</td>
                <td>{{l.cuentaSap}}</td>
                <td>{{l.comentarioAerovale}}</td>
                <td>{{l.expendedora}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="justify-content: center;" *ngIf="obteniendoPreciosScroll" class="d-flex align-items-center text-primary">
          <div class="spinner-border" role="status"></div><span>Cargando mas datos..</span>
        </div>
      }
    </div>
  </form>
</div>

